import { styled, Box } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

export const MenuWrapper = styled(Box)`
  display: flex;
  margin-left: auto;

  ${theme.breakpoints.down('lg')} {
    display: none;
  }
`;
